import React,{useEffect} from 'react';
import {connect} from 'react-redux';
import Countdown from 'react-countdown';
import {logout} from '../store/authActions';
import {clearStartTime} from '../store/teachActions';

const AutoLogout = ({logout,clearStartTime,startTime})=> {
  const expiration = 900000;
  //const expiration = 60000;

  useEffect(()=>{
    setTimeout(()=>{
      clearStartTime();
      logout();
    },expiration);
  //eslint-disable-next-line
  },[]);

  const onLogout = () => {
    clearStartTime();
    logout();
  };

  return (
    <>
      { startTime !== null &&
        <div className='row' style={{'padding':'10px 0px 0px 0px'}}>
          <div className='col s3'>
            auto logout in <Countdown date={Number(startTime)+expiration} />
          </div>
          <div className='col s9 right-align'>
            <button className="waves-effect waves-light deep-orange btn-small" onClick={onLogout}>Logout</button>
          </div>
        </div>
      }
    </>
  );
};

const matStoreToProps = state => ({
  startTime: state.teach.startTime
});

export default connect(matStoreToProps,{logout,clearStartTime})(AutoLogout);
